import React, { useEffect, useState } from 'react';

import { Modal, Tooltip } from 'reactstrap';

import ImgPlaceholder from '~/assets/img/ImgPlaceholder.png';
import { useCart } from '~/context/OrderingSystem/Cart';

import Product from '~/pages/OrderingSystem/Product';
import { startingPrice } from '~/utils/functions';
import formatValue from '~/utils/formatValue';
import { TypeBadge } from '~/components/TypeBadge';
import { useAuth } from '~/context/AuthContext';
import { Container, CountBadge, ProductImage, ProductInfo } from './styles';

const OrderingSystemProduct = React.memo(function OrderingSystemProduct({
  product,
  isTableDelivery,
  setAdded,
  toggleProductArea,
  hasCodebar,
  setHasCodebar,
  scannedBarcode,
}) {
  const [modalProductIsOpen, setModalProductIsOpen] = useState(false);
  const [itemProduct, setItemProduct] = useState();
  // const [count, setCount] = useState('');
  const { addToCart, countProducts, productsHasCounted } = useCart();
  const { user } = useAuth();

  function toggleModalProduct() {
    setModalProductIsOpen(!modalProductIsOpen);
  }

  function closeProductModal() {
    setModalProductIsOpen(false);
  }

  function extractScaleCode(barcode) {
    if (!barcode || barcode.length < 7) return null;

    const codeWithoutIdentifier = barcode.slice(0, -1);

    const scaleCode = codeWithoutIdentifier.slice(-5);

    return scaleCode;
  }

  function handleSelectProduct(product, scannedBarcodeInner) {
    if (
      (product?.complement_categories.length > 0 || product?.use_weight) &&
      !hasCodebar
    ) {
      if (isTableDelivery) {
        setItemProduct({
          ...product,
          price:
            product?.delivery_price_promotion ||
            product?.delivery_price ||
            product?.price_promotion ||
            product?.price,
        });
      } else {
        setItemProduct({
          ...product,
          price: product?.price_promotion || product?.price,
        });
      }

      toggleProductArea(
        isTableDelivery
          ? {
            ...product,
            price:
              product?.delivery_price_promotion ||
              product?.delivery_price ||
              product?.price_promotion ||
              product?.price,
          }
          : {
            ...product,
            price: product?.price_promotion || product?.price,
          }
      );
    } else if (
      product?.use_weight &&
      user.ean_scale_mode !== 'none' &&
      hasCodebar
    ) {
      const codeSliced = extractScaleCode(scannedBarcodeInner);

      const priceFormatted = parseInt(codeSliced, 10) / 100;
      const weightFormatted = (priceFormatted / product.price).toFixed(3);

      if (product.ean_codes && product.ean_codes.length > 0) {
        if (product.ean_codes[0].startsWith('$')) {
          countProducts({ id: product.id, amount: 1 });
          const productFormatted = isTableDelivery
            ? {
              ...product,
              price:
                product.delivery_price_promotion ||
                product.delivery_price ||
                product.price_promotion ||
                product.price,
            }
            : {
              ...product,
              price: product.price_promotion || product.price,
            };

          addToCart({
            product: productFormatted,
            amount: 1,
            observation: '',
            complementsCategory: [],
            isProductWeight: product?.use_weight,
            inputProductWeight: weightFormatted,
            inputProductPrice: parseInt(codeSliced, 10) / 100,
          });
        }

        if (product.ean_codes[0].startsWith('#')) {
          countProducts({ id: product.id, amount: 1 });
          const productFormatted = isTableDelivery
            ? {
              ...product,
              price:
                product.delivery_price_promotion ||
                product.delivery_price ||
                product.price_promotion ||
                product.price,
            }
            : {
              ...product,
              price: product.price_promotion || product.price,
            };

          addToCart({
            product: productFormatted,
            amount: 1,
            observation: '',
            complementsCategory: [],
            isProductWeight: product?.use_weight,
            inputProductWeight: parseInt(codeSliced) / 1000,
          });
        }
      }
    } else {
      countProducts({ id: product.id, amount: 1 });
      const productFormatted = isTableDelivery
        ? {
          ...product,
          price:
            product.delivery_price_promotion ||
            product.delivery_price ||
            product.price_promotion ||
            product.price,
        }
        : {
          ...product,
          price: product.price_promotion || product.price,
        };
      if (setAdded) {
        setAdded((state) => {
          const exists = state.find(
            (s) => s.product.id === productFormatted.id
          );
          if (exists) {
            return state.map((s) => {
              if (s.product.id === productFormatted.id) {
                return { ...s, amount: s.amount + 1 };
              }
              return s;
            });
          }
          return [
            ...state,
            {
              product: productFormatted,
              amount: 1,
              observation: '',
              complementsCategory: [],
              isProductWeight: product?.use_weight,
              created_at: new Date().toDateString(),
            },
          ];
        });
      }
      addToCart({
        product: productFormatted,
        amount: 1,
        observation: '',
        complementsCategory: [],
        isProductWeight: product?.use_weight,
      });
    }
  }

  const productStartingPrice = product?.has_starting_price
    ? startingPrice(product?.complement_categories, isTableDelivery)
    : 0;

  const handlePrice = (product, is_delivery) => {
    const is_combo = product.is_combo;
    let base_price = 0;

    const {
      price,
      delivery_price,
      combo_price,
      combo_delivery_price,
      price_promotion,
      delivery_price_promotion,
      combo_price_promo,
      combo_delivery_price_promo,
    } = product;

    if (is_delivery) {
      const hasPromo = delivery_price_promotion && delivery_price_promotion > 0;

      if (hasPromo) {
        base_price = is_combo
          ? Number(combo_delivery_price_promo ?? delivery_price_promotion)
          : Number(delivery_price_promotion);
      } else {
        base_price = is_combo
          ? Number(combo_delivery_price ?? delivery_price ?? price ?? 0)
          : Number(delivery_price ?? price ?? 0);
      }
    } else {
      const hasPromo = price_promotion && price_promotion > 0;

      if (hasPromo) {
        base_price = is_combo
          ? Number(combo_price_promo ?? price_promotion)
          : Number(price_promotion);
      } else {
        base_price = is_combo
          ? Number(combo_price ?? price ?? 0)
          : Number(price ?? 0);
      }
    }

    return formatValue(base_price + productStartingPrice);
  };

  useEffect(() => {
    if (hasCodebar && product) {
      handleSelectProduct(product, scannedBarcode);
      setHasCodebar(false);
    }
  }, [hasCodebar, product, setHasCodebar, scannedBarcode]);

  // tooltip
  const [productTooltip, setProductTooltip] = useState([]);

  function toggleTip(id) {
    if (productTooltip.includes(id)) {
      setProductTooltip([]);

      return;
    }
    setProductTooltip([id]);
  }

  return (
    <>
      <Container
        onClick={() => {
          handleSelectProduct(product);
        }}
        id={`product-${product.id}`}
      >
        <Tooltip
          key={product.id}
          isOpen={productTooltip.includes(product.id)}
          toggle={() => toggleTip(product.id)}
          target={`product-${product.id}`}
        >
          {product.ean_codes?.length === 1 ? (
            <p style={{ fontSize: 14 }}>
              {product.ean_codes[0].slice(1)} - {product.name}
            </p>
          ) : (
            <p>{product.name}</p>
          )}
        </Tooltip>

        {product.is_combo && <TypeBadge type="COMBO" />}
        {product.use_weight && <TypeBadge type="PESO" />}

        <ProductImage
          src={
            product?.image?.url_thumb || product?.image?.url || ImgPlaceholder
          }
          alt={product?.name}
        />
        {isTableDelivery ? (
          <ProductInfo>
            <h5>{product?.name}</h5>
            {product?.price_promotion || product?.delivery_price_promotion ? (
              <span>
                {handlePrice(
                  product,
                  isTableDelivery
                )}
              </span>
            ) : (
              <span>
                {handlePrice(product, isTableDelivery)}
              </span>
            )}
          </ProductInfo>
        ) : (
          <ProductInfo>
            <h5>{product?.name}</h5>
            {product?.price_promotion ? (
              <span>{handlePrice(product, isTableDelivery)}</span>
            ) : (
              <span>{handlePrice(product, isTableDelivery)}</span>
            )}
          </ProductInfo>
        )}

        {productsHasCounted &&
          productsHasCounted.find((pr) => pr.id === product.id)?.amount > 0 && (
            <CountBadge>
              {productsHasCounted.find((pr) => pr.id === product.id)?.amount}
            </CountBadge>
          )}
      </Container>
      <Modal isOpen={modalProductIsOpen} toggle={toggleModalProduct}>
        <Product
          product={itemProduct}
          closeProductModal={closeProductModal}
          isTableDelivery={isTableDelivery}
          countProducts={countProducts}
          setAdded={setAdded}
        />
      </Modal>
    </>
  );
});

export default OrderingSystemProduct;
